import text from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import UILink from 'UIComponents/link/UILink';
import ImageLoadingTypes from 'ContentUtils/constants/ImageLoadingTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.image.${key}`;
const LoadingSelect = ({
  onChange,
  readOnly,
  useOnDark,
  value
}) => {
  const lazyLoadingOptions = [{
    text: text(i18nKey('lazyLoading.disabled')),
    value: ImageLoadingTypes.DISABLED
  }, {
    text: text(i18nKey('lazyLoading.lazy')),
    value: ImageLoadingTypes.LAZY
  }, {
    text: text(i18nKey('lazyLoading.eager')),
    value: ImageLoadingTypes.EAGER
  }];
  const onLazyLoadingChange = e => {
    onChange(e.target.value);
  };
  const learnMoreLink = /*#__PURE__*/_jsx(UILink, {
    href: 'https://web.dev/browser-level-image-lazy-loading/',
    external: true,
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: i18nKey('lazyLoading.learnMore')
    })
  });
  return /*#__PURE__*/_jsx(UIFormControl, {
    className: "m-top-2",
    tooltipPlacement: 'top',
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('lazyLoading.label')
    }),
    tooltip: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: i18nKey('lazyLoading.loadingValueHelp'),
      options: {
        learnMoreLink
      }
    }),
    children: /*#__PURE__*/_jsx(UISelect, {
      buttonUse: useOnDark ? 'form-on-dark' : 'form',
      onChange: onLazyLoadingChange,
      options: lazyLoadingOptions,
      readOnly: readOnly,
      value: value || ImageLoadingTypes.DISABLED
    })
  });
};
export default LoadingSelect;